import {
  useCallback,
  useEffect,
  useState,
} from 'react';
import { useSelector } from 'react-redux';
import { APP } from '../../../config';
import { useUserStateRedux } from '../../../hooks';
import type { RootState } from '../../../store/models';
import { RATE_THIS_APP_DISMISSED, RATE_THIS_APP_DISMISSED_TWICE } from './constants';

export const useRateThisAppOpen = (appointmentId: number) => {
  const previousRoute = useSelector((state: RootState) => state.route?.previous?.name);

  const [
    dismissedOnce, setDismissedOnce, loadedUserState,
  ] = useUserStateRedux(RATE_THIS_APP_DISMISSED);
  const [dismissedTwice, setDismissedTwice] = useUserStateRedux(RATE_THIS_APP_DISMISSED_TWICE);

  const [isRateThisAppOpen, setRateThisAppOpen] = useState<boolean>(false);

  useEffect(() => {
    if (APP && (previousRoute || '').indexOf('booking.confirmation') !== -1) {
      setTimeout(async () => {
        if (loadedUserState && !dismissedTwice) {
          setRateThisAppOpen(true);
        }
      }, 3000);
    }
  }, [
    appointmentId,
    previousRoute,
    loadedUserState,
    dismissedTwice,
  ]);

  const handleClose = useCallback(async (fullyDismiss: boolean) => {
    if (loadedUserState && (dismissedOnce || fullyDismiss)) {
      await setDismissedTwice(true);
    } else {
      await setDismissedOnce(true);
    }
    setRateThisAppOpen(false);
  }, [
    setRateThisAppOpen,
    loadedUserState,
    dismissedOnce,
    setDismissedOnce,
    setDismissedTwice,
  ]);

  return {
    isRateThisAppOpen,
    handleClose,
  };
};
